<template>
  <v-layout fill-height justify-center>

    <div v-if="isUserAuthenticated">
      <NavigationToolbar :title="'Maple Bear - PWA'">
        <template>
          <v-layout fill-height justify-center align-center>
            <NotFound />
          </v-layout>
        </template>
      </NavigationToolbar>
    </div>

    <div v-else>
      <NotFound />
    </div>

  </v-layout>
</template>

<script>
import NavigationToolbar from '@/layouts/NavigationToolbar'
import { auth } from '@/services/'
import NotFound from '@/components/placeholders/NotFound'

export default {
  name: 'page-not-found',

  components: {
    NavigationToolbar,
    NotFound
  },

  computed: {
    isUserAuthenticated () {
      const data = auth.getUserAuthData()
      return data !== null || 'undefined'
    }
  }
}
</script>
